import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import {
  acceptProvenance,
  IRequestAddProvenance,
  rejectProvenance,
} from '../../actions/provenances/addProvenance'
import {
  deletedProvenance,
  IRequestDeleteProvenance,
  rejectDeleteProvenance,
} from '../../actions/provenances/deleteProvenance'
import {
  acceptProvenances,
  IRequestProvenances,
  rejectProvenances,
} from '../../actions/provenances/loadProvenances'
import { IProvenance } from '../../models/Provenance'
import CreateProvenance from '../../models/Provenance/CreateProvenance'
import DeleteProvenance from '../../models/Provenance/DeleteProvenance'
import fetchProvenances from '../../models/Provenance/fetchProvenances'
import { ProvenancesActions } from '../../reducers/provenances/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* loadProvenances(action: IRequestProvenances) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchProvenances)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchProvenances),
      ),
    ])

    const provenances: IProvenance[] = yield Effects.call(
      service,
      action.modifyDate,
    )
    yield Effects.put(acceptProvenances(provenances))
  } catch (e) {
    yield Effects.put(rejectProvenances(e.message))
  }
}

function* addProvenance(action: IRequestAddProvenance) {
  try {
    const actionNames = fetchActionsName(ActionNames.CreateProvenance)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, CreateProvenance),
      ),
    ])

    const provenance: IProvenance[] = yield Effects.call(
      service,
      action.provenance,
    )
    yield Effects.put(acceptProvenance(provenance))
  } catch (e) {
    yield Effects.put(rejectProvenance(e.message))
  }
}

function* deleteProvenance(action: IRequestDeleteProvenance) {
  try {
    const actionNames = fetchActionsName(ActionNames.CreateProvenance)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, DeleteProvenance),
      ),
    ])

    yield Effects.call(service, action.provenanceId)
    yield Effects.put(deletedProvenance(action.provenanceId))
  } catch (e) {
    yield Effects.put(rejectDeleteProvenance(e.message))
  }
}

export default function*() {
  yield Effects.takeEvery(
    ProvenancesActions.RequestForProvenances,
    loadProvenances,
  )
  yield Effects.takeLatest(
    ProvenancesActions.RequestAddProvenance,
    addProvenance,
  )
  yield Effects.takeLatest(
    ProvenancesActions.RequestDeleteProvenance,
    deleteProvenance,
  )
}
